// In Text.tsx
import { createText } from '@shopify/restyle';

import { Theme } from '../../../themes/theme';

const Text = createText<Theme>();

export default Text;
